export enum ClientsDisplayBodys {
  ClientsTableDisplay = 'Table view',
  ClientsMapDisplay = 'Map view',
}
